import { OtpAuthForm } from '../components/OtpAuthForm'

export function RegisterPage() {
	return <OtpAuthForm mode="register" />
}
